(() => {
  const storageKey = 'h59:favorites:v1';
  const script = document.querySelector('script[src*="h59-favorites.js"]');
  const strings = {
    add: script?.dataset.add || 'Add to favorites',
    remove: script?.dataset.remove || 'Remove from favorites',
    title: script?.dataset.title || 'My Items',
    empty: script?.dataset.empty || 'You have not saved any favorites yet.',
    view: script?.dataset.view || 'View product',
    close: script?.dataset.close || 'Close favorites'
  };

  const readFavorites = () => {
    try {
      const value = JSON.parse(localStorage.getItem(storageKey) || '[]');
      return Array.isArray(value) ? value.filter((item) => item && item.id && item.url) : [];
    } catch (error) {
      return [];
    }
  };

  const writeFavorites = (items) => {
    localStorage.setItem(storageKey, JSON.stringify(items));
    syncInterface();
  };

  const itemFromButton = (button) => {
    const url = new URL(button.dataset.h59Url || '/', window.location.origin).href;
    const pathHandle = new URL(url).pathname.split('/').filter(Boolean).pop() || url;
    const handle = button.dataset.h59Handle || pathHandle;
    return {
      id: handle,
      handle,
      title: button.dataset.h59Title || handle,
      url,
      image: button.dataset.h59Image || '',
      price: button.dataset.h59Price || ''
    };
  };

  const syncInterface = () => {
    const favorites = readFavorites();
    const ids = new Set(favorites.map((item) => item.id));
    document.querySelectorAll('[data-h59-favorite]').forEach((button) => {
      const item = itemFromButton(button);
      const selected = ids.has(item.id);
      button.setAttribute('aria-pressed', String(selected));
      button.setAttribute('aria-label', selected ? strings.remove : strings.add);
      const label = button.querySelector('.h59-favorite-button__text');
      if (label) label.textContent = selected ? strings.remove : strings.add;
    });
    document.querySelectorAll('[data-h59-favorites-count]').forEach((count) => {
      count.textContent = String(favorites.length);
      count.hidden = favorites.length === 0;
    });
    renderDialog(favorites);
  };

  const createDialog = () => {
    const dialog = document.createElement('dialog');
    dialog.className = 'h59-favorites-dialog';
    dialog.dataset.h59FavoritesDialog = '';
    const inner = document.createElement('div');
    inner.className = 'h59-favorites-dialog__inner';
    const header = document.createElement('div');
    header.className = 'h59-favorites-dialog__header';
    const title = document.createElement('h2');
    title.textContent = strings.title;
    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'h59-favorites-dialog__close';
    close.dataset.h59FavoritesClose = '';
    close.setAttribute('aria-label', strings.close);
    close.textContent = '×';
    const list = document.createElement('div');
    list.className = 'h59-favorites-dialog__list';
    list.dataset.h59FavoritesList = '';
    header.append(title, close);
    inner.append(header, list);
    dialog.append(inner);
    document.body.append(dialog);
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
    return dialog;
  };

  const getDialog = () => document.querySelector('[data-h59-favorites-dialog]') || createDialog();

  const renderDialog = (favorites = readFavorites()) => {
    const dialog = document.querySelector('[data-h59-favorites-dialog]');
    if (!dialog) return;
    const list = dialog.querySelector('[data-h59-favorites-list]');
    list.replaceChildren();
    if (favorites.length === 0) {
      const empty = document.createElement('p');
      empty.className = 'h59-favorites-dialog__empty';
      empty.textContent = strings.empty;
      list.append(empty);
      return;
    }
    favorites.forEach((item) => {
      const row = document.createElement('article');
      row.className = 'h59-favorites-dialog__item';
      if (item.image) {
        const image = document.createElement('img');
        image.src = item.image;
        image.alt = '';
        image.loading = 'lazy';
        row.append(image);
      } else {
        const placeholder = document.createElement('span');
        placeholder.setAttribute('aria-hidden', 'true');
        row.append(placeholder);
      }
      const details = document.createElement('div');
      const title = document.createElement('a');
      title.className = 'h59-favorites-dialog__item-title';
      title.href = item.url;
      title.textContent = item.title;
      details.append(title);
      if (item.price) {
        const price = document.createElement('span');
        price.className = 'h59-favorites-dialog__item-price';
        price.textContent = item.price;
        details.append(price);
      }
      const link = document.createElement('a');
      link.className = 'h59-favorites-dialog__item-link';
      link.href = item.url;
      link.textContent = strings.view;
      details.append(link);
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'h59-favorites-dialog__remove';
      remove.dataset.h59FavoriteRemove = item.id;
      remove.setAttribute('aria-label', `${strings.remove}: ${item.title}`);
      remove.textContent = '♥';
      row.append(details, remove);
      list.append(row);
    });
  };

  const toggleFavorite = (button) => {
    const item = itemFromButton(button);
    const favorites = readFavorites();
    const existingIndex = favorites.findIndex((favorite) => favorite.id === item.id);
    if (existingIndex >= 0) favorites.splice(existingIndex, 1);
    else favorites.push(item);
    writeFavorites(favorites);
  };

  document.addEventListener('click', (event) => {
    const favoriteButton = event.target.closest('[data-h59-favorite]');
    if (favoriteButton) {
      event.preventDefault();
      event.stopPropagation();
      toggleFavorite(favoriteButton);
      return;
    }
    const opener = event.target.closest('[data-h59-favorites-open]');
    if (opener) {
      event.preventDefault();
      const dialog = getDialog();
      renderDialog();
      if (!dialog.open) dialog.showModal();
      return;
    }
    const closer = event.target.closest('[data-h59-favorites-close]');
    if (closer) {
      closer.closest('dialog')?.close();
      return;
    }
    const remove = event.target.closest('[data-h59-favorite-remove]');
    if (remove) {
      const favorites = readFavorites().filter((item) => item.id !== remove.dataset.h59FavoriteRemove);
      writeFavorites(favorites);
    }
  });

  window.addEventListener('storage', syncInterface);
  document.addEventListener('shopify:section:load', syncInterface);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncInterface);
  else syncInterface();
})();
